import { lazy } from "react";

export const ApplicationFooter = lazy(() => import("./ApplicationFooterContainer"));
